import { AgmCoreModule } from "@agm/core";
import { CommonModule } from "@angular/common";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { ReactiveFormsModule } from "@angular/forms";
import { MatIconModule, MatStepperModule } from "@angular/material";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule, NoopAnimationsModule } from "@angular/platform-browser/animations";
import { CoreModule } from "@siu/core";
import { SharedModule } from "@siu/shared";
import { AgmDirectionModule } from "agm-direction";
import { QRCodeModule } from "angularx-qrcode";
import { NgxBarcode6Module } from "ngx-barcode6";
import { NgxSpinnerModule } from "ngx-spinner";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { AuthInterceptor } from "./core/interceptors/auth-interceptor";
import { TransversalModule } from "./shared/src/transversal/transversal.module";

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    NoopAnimationsModule,
    AppRoutingModule,
    CommonModule,
    SharedModule,
    CoreModule,
    TransversalModule,
    HttpClientModule,
    ReactiveFormsModule,
    MatStepperModule,
    AgmCoreModule.forRoot({
      // apiKey: "AIzaSyAH2Fhr5uKYwZGRIOTcNMplBFETh4gLlhI",
      apiKey: "AIzaSyCAsetl9wxV5zrKX-wiRAlKgejLWfNqeKg",
    }),
    AgmDirectionModule,
    FlexLayoutModule,
    NgxBarcode6Module,
    NgxSpinnerModule,
    QRCodeModule,
    MatIconModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
